import { clean } from './clean';

export function _cleanSearchArguments(string = '', query = '', options = {}) {
  return {
    string: clean(string, options),
    query: clean(query, options),
    options,
  };
}
